import { isPlainObject as e } from "./index27.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/stringifyTheme.js
function t(t) {
	return e(t) || t === void 0 || typeof t == "string" || typeof t == "boolean" || typeof t == "number" || Array.isArray(t);
}
function n(n = {}) {
	let r = { ...n };
	function i(n) {
		let r = Object.entries(n);
		for (let a = 0; a < r.length; a++) {
			let [o, s] = r[a];
			!t(s) || o.startsWith("unstable_") ? delete n[o] : e(s) && (n[o] = { ...s }, i(n[o]));
		}
	}
	return i(r), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(r, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
//#endregion
export { n as stringifyTheme };

//# sourceMappingURL=index96.js.map